export default __webpack_public_path__ + "static/media/Maria.8d9f4b31.jpeg";